/** @format */

import WebshopCookies from "./../library/WebshopCookies";
import Header from "./Header";

export default class Webshop {
	constructor() {
		this.instance = self;
		this.configureCookieDomains();
		this.webshopCookieName = "webshop_product_refer";
		this.bannerInsertionPoint = ".header";
	}

	configureCookieDomains() {
		const baseUrl = window.site.baseUrl;
		const urlObj = new URL(baseUrl.startsWith("http") ? baseUrl : `https://${baseUrl}`);

		if (baseUrl.includes(".internal")) {
			this.cookieDomain = ".surridgesport.internal";
			this.mainWebsite = "www.surridgesport.internal";
			this.webshopDomain = ".surridgesport.internal";
		} else if (baseUrl.includes("surridgesportdev.com")) {
			this.cookieDomain = ".surridgesportdev.com";
			this.mainWebsite = "www.surridgesportdev.com";
			this.webshopDomain = ".surridgesportdev.com";
		} else {
			this.cookieDomain = ".surridgesport.com";
			this.mainWebsite = "www.surridgesport.com";
			this.webshopDomain = ".surridgesport.com";
		}

		if (!urlObj.hostname.startsWith("www.")) {
			const parts = urlObj.hostname.split(".");
			if (parts.length > 2) {
				this.webshopDomain = `.${parts.slice(-2).join(".")}`;
				this.cookieDomain = this.webshopDomain;
			}
		}
	}

	static init() {
		const self = new Webshop();

		self.attachEvents();
	}

	attachEvents() {
		if (this.isMainSite()) {
			const webshopData = this.getWebshopReferrerData();

			if (webshopData) {
				this.createAndShowBanner(webshopData);
			}
		}

		if (!this.isMainSite() && !document.referrer.includes(this.mainWebsite)) {
			WebshopCookies.deleteCookie(this.webshopCookieName, "/", this.cookieDomain);
		}

		$(document)
			.on("click", ".js-delete-webshop-referer-cookie", (e) => {
				WebshopCookies.deleteCookie(this.webshopCookieName, "/", this.cookieDomain);
			})
			.on("click", ".js-on-click-webshop-continue-to-core-product", (e) => {
				e.preventDefault();
				this.createWebshopData($(e.currentTarget));
			})
			.on("click", ".js-close-webshop-banner", (e) => {
				e.preventDefault();

				$(".js-webshop-referer-banner").remove();

				// Need to update header ghost now
				Header.refreshHeader();

				WebshopCookies.deleteCookie(this.webshopCookieName, "/", this.cookieDomain);
			});
	}

	createAndShowBanner(webshopData) {
		if (!webshopData) return;

		// Create new banner
		const $banner = $(this.generateBannerHTML(webshopData));

		// Apply dynamic styles
		if (webshopData.webshopColour) {
			$banner.css("background-color", webshopData.webshopColour);
		}

		// Insert and show banner
		$(this.bannerInsertionPoint).prepend($banner.show());
	}

	generateBannerHTML(webshopData) {
		const textColor = webshopData.webshopColourInvert
			? `style="color:${webshopData.webshopColourInvert}"`
			: "";

		const svgFill = webshopData.webshopColourInvert
			? `fill="${webshopData.webshopColourInvert}"`
			: 'fill="currentColor"';

		return `
            <div class="header-top header-banner-top js-webshop-referer-banner">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col">
							<div class="d-inline-flex align-items-center">
								<span class="mr-2">
									<span class="svg-icon mod-chevron-left">
										<svg xmlns="http://www.w3.org/2000/svg" width="4.002" height="6.698" viewBox="5.667 4.664 4.002 6.698" class="svg" ${svgFill}>
											<path d="M5.667 8a.664.664 0 01.193-.473L8.527 4.86a.668.668 0 11.945.947L7.267 8l2.12 2.2a.666.666 0 11-.959.92L5.853 8.453A.667.667 0 015.667 8z"></path>
										</svg>
									</span>
								</span>
								<a
									class="d-block td-none js-delete-webshop-referer-cookie"
									href="${webshopData.webshopUrl || "/"}"
									rel="nofollow"
									${textColor}
								>
									Return to <span class="js-webshop-referer-name">${webshopData.webshopName || "the webshop"}</span>
								</a>
							</div>
                        </div>
                        <div class="col-auto">
                            <a href="#" class="js-close-webshop-banner btn-close" ${textColor} aria-label="Close banner" rel="nofollow">
                                &times;
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
	}

	isMainSite() {
		return window.location.hostname === this.mainWebsite;
	}

	getWebshopReferrerData() {
		const webshopReferCookie = WebshopCookies.getCookie(this.webshopCookieName);
		if (!webshopReferCookie) return null;

		try {
			return JSON.parse(webshopReferCookie);
		} catch (e) {
			// console.error("Error parsing webshop referrer cookie:", e);
			WebshopCookies.deleteCookie(this.webshopCookieName, "/", this.cookieDomain);
			return null;
		}
	}

	createWebshopData($btn) {
		const cookieData = $.extend(
			{
				webshopUrl: $btn.data("webshop-url") || "/",
			},
			$btn.data()
		);

		WebshopCookies.setCookie(
			this.webshopCookieName,
			JSON.stringify(cookieData),
			1, // 1 day expiry
			"/",
			this.cookieDomain
		);

		setTimeout(() => {
			window.location = $btn.attr("href");
		}, 100);
	}
}
